<template>
  <div class="contributors">
    <h2 class="contributors__title">{{ t('efriends.contributorsTitle') }}</h2>
    <div class="contributors__list">
      <transition-group name="contributors__list-item" tag="div">
        <div
          v-for="contributor in contributors"
          :key="contributor.cubeName"
          class="contributors__list-item"
        >
          <Contributor :cube="contributor" />
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
  import Contributor from '@/components/efriends/Contributor.vue'
  import { useStrings } from '@/composables/useStrings.ts'
  import { useCubeStore } from '@/stores/useCubeStore'

  export default {
    name: 'contributors',
    setup(){
      const cubeStore = useCubeStore()
      const { t } = useStrings()
      return {
        t,
        cubeStore,
      }
    },
    components: {
      Contributor,
    },
    computed: {
      consumers() {
        return this.cubeStore.consumers
      },
      producers() {
        return this.cubeStore.producers
      },
      contributors() {
        let contributors = {}
        this.cubeStore.consumers.map((cube) => {
          if (cube.isContributor) {
            contributors[cube.cubeName] = cube
          }
        })

        this.cubeStore.producers.map((cube) => {
          if (cube.isContributor) {
            contributors[cube.cubeName] = cube
          }
        })

        return Object.entries(contributors).map((row) => {
          return row[1]
        })
      },
    },
  }
</script>

<style lang="scss">
  .contributors {
    margin: $spacer20 auto 0;
    max-width: 800px;

    &__list {
      &-item {
        transition: all 1s ease-in-out 0s;
        margin: 0;

        &-leave-active {
          max-height: 0;
          padding-top: 0;
          padding-bottom: 0;
          border-width: 0;
          overflow: hidden;
        }

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
</style>
